import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface LocationDetectorProps {
  detectedCountry: string;
  onDetectedCountryChange: (country: string) => void;
}

export default function LocationDetector({
  detectedCountry,
  onDetectedCountryChange,
}: LocationDetectorProps) {
  useEffect(() => {
    async function detectLocation() {
      try {
        const { data, error } = await supabase.functions.invoke('get-approx-location');
        
        if (error) {
          console.error('Error detecting location:', error);
          return;
        }

        if (data?.country) {
          onDetectedCountryChange(data.country);
        }
      } catch (err) {
        console.error('Location detection failed:', err);
      }
    }

    detectLocation();
  }, [onDetectedCountryChange]);

  return null;
}
